import axios from 'axios';
import authHeader from "@/service/auth-header";

class LocationService {

    async getCompanyLocations(companyId) {
        return await axios.get(`/api/location/${companyId}`, {headers: authHeader()})
    }

    async searchCompanyLocations(companyId, locationName) {
        return await axios.get(`/api/location/${companyId}/${locationName}`, {headers: authHeader()})
    }

    async getLocation(locationId) {
        return await axios.get(`/api/location/specific/${locationId}`, {headers: authHeader()})
    }

    async createLocation(companyId, data) {
        return await axios.post(`/api/location/${companyId}`, data, {headers: authHeader()});
    }

    async updateLocation(locationId, data) {
        return await axios.put(`/api/location/${locationId}`, data, {headers: authHeader()});
    }

    async deleteLocation(locationId) {
        return await axios.delete(`/api/location/${locationId}`, {headers: authHeader()})
    }

}

export default new LocationService();
